import React from 'react';
import Component from '../../components/Component';
import Datagrid from '../../components/Datagrid';
import Renderers from '../../helpers/Renderers';
import DbInfo from '../../dbinfo';
import c from '../../constants';
import {FormManager} from 'reactis-forms';
import {FilterInput, Select, SearchInput} from 'reactis-inputs';
import {FilterResetButton, FilterField} from 'reactis-datagrid';
import {Button, ButtonToolbar, OverlayTrigger, Tooltip} from 'react-bootstrap';
import {AlertWindow} from 'reactis-modal';
import EventEmitter from '../../EventEmitter';
import DateRange from '../../components/Form/DateRange';
import DocumentTitle from 'react-document-title';
import {connect} from 'react-redux';
import ActiveSelect from '../../components/Form/ActiveSelect';
import {bindActionCreators} from 'redux';
import SectorPicker from '../../components/Form/SectorPicker';
import store from "store2";
import ClientLookup from "../../components/Form/ClientLookup";


export default class List extends Component {

	static contextTypes = {
		location: React.PropTypes.object
	};

	constructor(props, context) {
		super(props);

		const rendererLink = (val, row) => {
			return <a href={'/vehicle/'+row.id} onClick={(e) => this.handleOpen(row, e)}>{val}</a>;
		};

    const rendererFiles = (val, row) => {
      const files = row.files.map(file => {
        const tooltip = <Tooltip id="file">{file.title}</Tooltip>
        return (
          <OverlayTrigger key={file.id} placement="top" overlay={tooltip}>
            <a style={{color: '#000'}} href={'/file/download/' + file.id}>
              <i style={{fontSize: 13}} className="glyphicon glyphicon-paperclip"/>
            </a>
          </OverlayTrigger>
        )
      });
      return <div>
        {files}
      </div>
    };

		this.columnModel = [
			{
				name: 'id',
				title: 'Ev. číslo',
				field: 'ev',
				width:80,
				renderer: rendererLink
			},
            {
                name: 'cTitle',
                title: 'Provozovatel',
                field: 'cTitle',
                viewport: 'tablet'
            },
            {
				name: 'eid',
				title: 'Podnik. č.',
				field: 'eid',
				viewport: 'tablet'
			},
			{
				name: 'make',
				title: 'Výrobce',
				field: 'make',
				viewport: 'tablet'
			},
			{
				name: 'model',
				title: 'Typ',
				field: 'model',
				viewport: 'tablet'
			},
			{
				name: 'year',
				title: 'Rok výr.',
				field: 'year',
				width:80,
				viewport: 'tablet'
			},
      {
        name: 'files',
        width: 58,
        title: <i style={{fontSize: 13}} className="glyphicon glyphicon-paperclip"/>,
        sortable: false,
        renderer: rendererFiles
      },
			{
				name: 'edit',
				title: 'Akce',
				field: 'id',
				width:80,
				sortable: false,
				renderer: (val, row) => {
					return (
						<a href={'/vehicle/'+val} onClick={(e) => this.handleOpen(row, e)}>
							<i className="fa fa-pencil position-left"></i>Upravit
						</a>
					);
				}
			}
		];

		const filterSchema = {
			title: { class: FilterInput },
			year: { class: FilterInput },
			make: { class: FilterInput },
			model: { class: FilterInput },
			eid: { class: FilterInput },
			id: { class: FilterInput },
			cTitle: { class: ClientLookup },
			fulltext: { class: SearchInput },
			edit: {
				class: FilterResetButton,
				visible: () => this.filter.isChanged(),
				onClick: () => this.filter.reset()
			}
		};
		this.filter = new FormManager(filterSchema);
		const sessionState = store.session.get('dg-vehicle');
		// default
		let filter = {};
		// session
		if (sessionState && sessionState.filter) {
			filter = sessionState.filter;
		}
		this.defaultFilter = filter;
		this.defaultSort = sessionState && sessionState.sort ? sessionState.sort : {column: 'id', 'direction': 'desc'};
	}

	componentDidMount() {
		this.changeListener = () => {
			this.refs.datagrid.getWrappedInstance().refresh();
		};
		EventEmitter.on('vehicle.change', this.changeListener);
	}

	componentWillUnmount() {
		EventEmitter.removeListener('vehicle.change', this.changeListener);
	}

	handleOpen(row, e) {
		e.preventDefault();
		this.props.actions.openTabForm('vehicle', row.ev, row);
	}

	handleNewClick(e) {
		e.preventDefault();
		this.props.newTab();
	}

	render() {

		const buttons = <Button href="/vehicle/0" onClick={(e) => this.handleNewClick(e)}>
			<i className="fa fa-plus position-left"/>Nový vozík
		</Button>;


		return (
			<Datagrid
				ref="datagrid"
				id="vehicle"
				api="vehicle.getList"
				buttons={buttons}
				filters={['fulltext']}
				filter={this.filter}
				saveState={true}
				getRowClassName={null}
				columnModel={this.columnModel}
				defaultFilter={this.defaultFilter}
				forceFilter={this.filterUrl}
				defaultSort={this.defaultSort}
			/>
		)
	}
}


// WEBPACK FOOTER //
// ./src/containers/Vehicle/List.js